import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const master = {
  cities: params => {
    const url = api.master.cities + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  paymentMethods: () => {
    const url = api.master.paymentMethods
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  goodsCategories: params => {
    const url = api.master.goodsCategories + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  goodsCategoryDetail: code => {
    const url = `${api.master.goodsCategories}/${code}`
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createGoodsCategory: payloads => {
    const url = api.master.goodsCategories
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  bankCodes: () => {
    const url = api.master.bankCodes
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  ownershipTypes: () => {
    const url = api.master.ownershipTypes
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  vehicleTypes: () => {
    const url = api.master.vehicleTypes
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  driverLicenseTypes: () => {
    const url = api.master.driverLicenseTypes
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  province: () => {
    const url = api.master.province
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  district: provinceId => {
    const url = api.master.district(provinceId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  subDistrict: (provinceId, districtId) => {
    const url = api.master.subDistrict(provinceId, districtId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  urbanVillage: (provinceId, districtId, subDistrictId) => {
    const url = api.master.urbanVillage(provinceId, districtId, subDistrictId)
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}
export default master
